export const END_MODIFYING_OPTIONS = {
  SAVE: "SAVE",
  CANCEL: "CANCEL"
};
